// import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useRouter } from "next/router";
import Pagination from '../../components/Pagination';
import Hero from '../../components/Hero';
import PageCardList from '../../components/PageCardList';
import styles from './PageListPage.module.scss';

const PageListPage = ({ settings = {
        hero: {},
        footer: {}
    }, hero, data = {} }) => {
    const router = useRouter()
    const PAGE_ITEMS_LIMIT = 9;

    const setGetArguments = (url, page) => {
        const _url = new URL(url, "https://dummy.url");
        if (page) {
            _url.searchParams.set("p", page);
        } else {
            _url.searchParams.delete("p");
        }
        return _url.pathname + _url.search;
    };

    const handlePaginationOnChange = (e) => {
        router.replace(setGetArguments(window.location, e), undefined, { scroll: true });
    }

    return (
        <div className={styles['PageListPage']}>
            <Header {...settings.header} />
            <main>
                {hero && <Hero {...hero} />}
                <div className={styles['PageListPage__Container']}>
                    <div className={styles['PageListPage__List']}>
                        <PageCardList items={data.items} />
                    </div>
                    {data && data.totalPages && data.totalPages > 1 && (
                        <div className={styles['PageListPage__Pagination']}>
                            <Pagination
                                totalPages={data.totalPages}
                                currentPage={data.currentPage}
                                itemsPerPage={PAGE_ITEMS_LIMIT}
                                pageUrl={data.paginationBaseUrl}
                                onPageChange={handlePaginationOnChange}
                            />
                        </div>
                    )}
                </div>
            </main>
            <Footer {...settings.footer} />
        </div>
    );
};

PageListPage.propTypes = {
    hero: PropTypes.object,
    footer: PropTypes.object,
    data: PropTypes.object,
};

export default basePageWrap(PageListPage);
